<template>
  <div>
    <div class="w3-container">
      <div class="headerGridCMS w3-hide-print">
        <div>
          <header>
            <h2><template v-if="$route.params.id">Edit</template><template v-else>New</template> Category</h2>
          </header>
        </div>
        <div>
          <button class='w3-button w3-right w3-small vmiddle w3-red' style="margin-left:8px;" @click="exitCategory()">Exit</button>
          <button class='w3-button w3-right w3-small vmiddle' :class="saving || saved ? 'w3-dark-teal' : 'w3-teal'" :disabled="saving || saved" @click="saveContent()"><span v-if="!saved">Save Category</span><span v-if="saved">Category Saved</span></button>
        </div>
      </div>
      <div class="categoryDetailGrid">
        <div>
          <div class="inputCard">
            <header class="w3-left-align">Main</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Title</label>
                <input v-model="category.title" placeholder="My Category" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>URL</label>
                <input v-model="category.slug" :placeholder="slug(category.title)" class="w3-input w3-border" />
              </div>
            </div>
          </div>
          <div class="inputCard">
            <header class="w3-left-align">Category Page SEO</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label>Meta Title</label>
                <input v-model="category.seo.title" class="w3-input w3-border" />
              </div>
              <div class="cardRow w3-padding-8">
                <label>Meta Description</label>
                <input v-model="category.seo.description" class="w3-input w3-border" />
              </div>
            </div>
          </div>
          <div class="inputCard">
            <header class="w3-left-align">Category Page Content</header>
            <div class="content">
              <tinymce-editor api-key="t5p4kok2r7znye5exinvmcmpazco8x8rd3hoapujd41dps8c" :init="state.tinymceInit" v-model="category.content"></tinymce-editor>
            </div>
          </div>
        </div>
        <div>
          <div class="inputCard">
            <header class="w3-left-align">Details</header>
            <div class="content">
              <div class="cardRow w3-padding-8">
                <label style="margin-top:6px;">Parent ID</label>
                <div>
                  <input v-model="category.parentid" class="w3-input w3-border w3-block w3-right-align" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
var slug = require('slug')
var dataStore = require('../../dataStore').default

export default {
  name: 'cmsproductcategoriesdetail',
  data() {
    return {
      state: dataStore.state,
      category: {},
      imageUpload: {
        src: '',
        alt: ''
      },
      saving: false,
      saved: false
    }
  },
  components: {
    'tinymce-editor': Editor
  },
  created() {
    this.initCategory()
    if (this.$route.params.id) {
      for (let savedCategory of this.state.siteData.content.products.categories) {
        if (Number(this.$route.params.id) === savedCategory.id) {
          this.category = savedCategory
          if (!this.category.seo) {
            this.category.seo = {
              title: '',
              description: ''
            }
          }
          break
        }
      }
      console.log(this.category)
    }
  },
  methods: {
    initCategory() {
      this.category = {
        id: Math.max.apply(Math, this.state.siteData.content.products.categories.map((category) => { return category.id })) + 1,
        title: '',
        description: '',
        images: [],
        seo: {
          title: '',
          description: ''
        },
        slug: ''
      }
    },
    slug(string) {
      return slug(string).toLowerCase()
    },
    saveContent() {
      if (this.category.slug === '') {
        this.category.slug = slug(this.category.title)
      }
      this.checkOverwrite().then((index) => {
        if (index > -2) {
          if (index > -1) {
            this.state.siteData.content.products.categories[index] = this.category
          } else {
            this.state.siteData.content.products.categories.push(this.category)
          }
          this.saving = true
          dataStore.saveSiteData().then((res) => {
            this.saving = false
            if (res === 'success') {
              this.$router.replace('/cms/product-categories')
            }
          })
        }
      })
    },
    saveCategory(category) {
      let itemIndex = this.state.siteData.content.products.categories.findIndex(savedCategory => savedCategory.id === category.id)
      if (itemIndex > -1) {
        this.state.siteData.content.products.categories[itemIndex] = category
        this.editingSlug = 0
        this.saveContent()
      }
    },
    checkOverwrite() {
      return new Promise(resolve => {
        let loopIndex = 0
        for (let category of this.state.siteData.content.products.categories) {
          if (category.slug === this.category.slug) {
            if (!confirm('Category with this Name already exists, overwrite?')) {
              resolve(-2)
            } else {
              resolve(loopIndex)
            }
          }
          loopIndex++
        }
        resolve(-1)
      })
    },
    exitCategory() {
      if (this.category.category) {
        this.category.category = this.category.category.id
      }
      this.initCategory()
      this.$router.go(-1)
    },
    mergeRecursive(obj1, obj2) {
      for (var p in obj2) {
        try {
          if (obj2[p].constructor === Object) {
            obj1[p] = this.mergeRecursive(obj1[p], obj2[p])
          } else {
            obj1[p] = obj2[p]
          }
        } catch (e) {
          obj1[p] = obj2[p]
        }
      }
      return obj1
    }
  }
}
</script>

<style scoped>
  .categoryTitle {font-size:1rem;}
  .categoryMeta {font-size:1rem; font-family: 'Roboto', sans-serif; text-align: center;}
  .categoryGrid {display:grid; grid-template-columns: 225px 1fr; grid-gap: 8px; border-bottom: 1px solid #ccc;}
  .categoryGrid:last-child {border-bottom:0;}
  .categoryContentGrid {display:grid; grid-template-columns: 1fr 250px 130px; grid-gap: 8px;}
  .buttons {text-align: right;}
  header.w3-left-align {padding-left:12px;}

  .categoryDetailGrid {display:grid; grid-template-columns: 3fr 1fr; grid-gap: 8px;}
@media screen and (max-width:993px) {
  .categoryTitle {font-size:10pt;}
  .categoryMeta {font-size:10pt; font-family: 'Roboto', sans-serif;}
  .categoryGrid {display:grid; grid-template-columns: 125px 1fr; grid-gap: 8px;}
}
</style>



// WEBPACK FOOTER //
// src/components/cms/cmsProductCategoriesDetail.vue